/* eslint-disable max-len */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { Transition } from '@headlessui/react';

import IconSvg from 'components/Core/IconSvg';

import { useKeyPress } from 'utils/hooks';
import { AppContext } from 'context/AppContext';

const Modal = ({ children }) => {
  const { openModal = false, updateAppState } = useContext(AppContext);

  const closeModal = () => {
    document.body.classList.remove('modal-open');
    updateAppState((state) => ({
      ...state,
      openModal: false,
      showCookieModal: false,
      showAccommodationModal: false,
    }));
  };

  useKeyPress('Escape', closeModal);

  return (
    openModal && (
      <div className="fixed z-110 inset-0 overflow-y-auto">
        <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <Transition
            show={openModal}
            enter="transition-opacity duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="transition-opacity duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
            className="fixed inset-0 transition-opacity"
            aria-hidden="true"
          >
            <div className="overlay-bg absolute w-full h-full bg-gray-900 opacity-50" />
          </Transition>

          {/* This element is to trick the browser into centering the modal contents. */}
          <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
            &#8203;
          </span>

          <Transition
            show={openModal}
            enter="transition-opacity ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="transition-opacity ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            className="relative inline-block align-bottom bg-white rounded-lg text-left overflow-hidden w-full max-h-screen-90 max-w-screen-sm shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-xl lg:max-w-4xl xl:max-w-5xl sm:w-full"
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal-headline"
          >
            <div className="bg-white mx-6 mt-5 mb-6 lg:my-12 lg:mx-32 relative">
              <button
                onClick={() => closeModal()}
                type="button"
                className="absolute right-0 top-0 cursor-pointer z-50"
              >
                <IconSvg icon="close" size={20} className="text-primary" aria-hidden="true" />
                <span className="sr-only">Sluiten</span>
              </button>
              {children}
            </div>
          </Transition>
        </div>
      </div>
    )
  );
};

Modal.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Modal;
